// src/App.js - VERSION CORRIGÉE

import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation, Link } from "react-router-dom"; // ← Ajoutez Link ici
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import { useAuth } from "./context/AuthContext";
import ScrollToTop from "./components/routing/ScrollToTop";


import Home from "./pages/Home";
import Deals from "./pages/Deals";
import DealDetail from "./pages/DealDetail";
import TopDeals from "./pages/TopDeals";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Dashboard from "./pages/user/Dashboard";
import Cart from "./pages/Cart";
import Checkout from "./pages/checkout";
import About from "./pages/About";
import Announcements from "./pages/Announcements";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";

import Experiences from "./pages/Experiences";
import LaserClinic from "./pages/LaserClinic";
import House from "./pages/House";
import Partner from "./pages/Partner";
import CGV from "./pages/CGV";
import Privacy from "./pages/Privacy";
import Legal from "./pages/Legal";
import FAQ from "./pages/FAQ";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";

import PrivateRoute from "./components/routing/PrivateRoute";
import NotFound from "./pages/NotFound";

import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminDealsManagement from "./pages/admin/AdminDealsManagement";
import AdminOrdersManagement from "./pages/admin/AdminOrdersManagement";
import AdminUsersManagement from "./pages/admin/AdminUsersManagement";
import AdminMerchantsManagement from "./pages/admin/AdminMerchantsManagement";
import AdminPerformanceDashboard from "./pages/admin/AdminPerformanceDashboard";
import AdminCitiesManagement from "./pages/admin/AdminCitiesManagement";
import AdminCategoriesManagement from "./pages/admin/AdminCategoriesManagement";
import AdminReviewsManagement from "./pages/admin/AdminReviewsManagement";
import AdminPaymentsManagement from "./pages/admin/AdminPaymentsManagement";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminNotifications from "./pages/admin/AdminNotifications";

import MerchantLayout from "./components/merchant/MerchantLayout";
import CreateDeal from "./pages/merchant/CreateDeal";
import EditDeal from "./pages/merchant/EditDeal";
import MyDeals from "./pages/merchant/MyDeals";

// ============================================================
// 🔍 DEBUG CONFIGURATION COMPONENT
// ============================================================
const ConfigDebugger = () => {
  useEffect(() => {
    const hostname = window.location.hostname;
    const isDev = process.env.NODE_ENV === 'development';
    
    const expectedAPI = hostname === 'maxula.halamall.shop' || hostname === 'www.maxula.halamall.shop'
      ? 'https://api.maxula.halamall.shop/api'
      : 'http://localhost:5000/api';
    
    const expectedBackend = hostname === 'maxula.halamall.shop' || hostname === 'www.maxula.halamall.shop'
      ? 'https://api.maxula.halamall.shop'
      : 'http://localhost:5000';

    console.group('🔧 MAXULA CONFIGURATION DEBUG');
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    console.log('%cEnvironment:', 'font-weight: bold', process.env.NODE_ENV);
    console.log('%cHostname:', 'font-weight: bold', hostname);
    console.log('%cisDev:', 'font-weight: bold', isDev);
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    console.log('%cEnvironment Variables:', 'font-weight: bold; color: #2196f3');
    console.log('  REACT_APP_API_URL:', process.env.REACT_APP_API_URL || '❌ NOT SET');
    console.log('  REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL || '❌ NOT SET');
    console.log('  REACT_APP_SITE_URL:', process.env.REACT_APP_SITE_URL || '❌ NOT SET');
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    console.log('%cExpected Values:', 'font-weight: bold; color: #4caf50');
    console.log('  Expected API:', expectedAPI);
    console.log('  Expected Backend:', expectedBackend);
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    
    const apiMatch = process.env.REACT_APP_API_URL === expectedAPI;
    const backendMatch = process.env.REACT_APP_BACKEND_URL === expectedBackend;
    
    console.log('%cValidation:', 'font-weight: bold; color: #ff9800');
    console.log(apiMatch ? '  ✅ API_URL is correct' : '  ❌ API_URL mismatch!');
    console.log(backendMatch ? '  ✅ BACKEND_URL is correct' : '  ❌ BACKEND_URL mismatch!');
    
    if (!apiMatch || !backendMatch) {
      console.log('%c⚠️ WARNING: Configuration mismatch detected!', 'background: #ff9800; color: white; padding: 4px 8px; font-weight: bold');
      console.log('%cPlease rebuild with correct environment variables', 'color: #ff9800');
    }
    
    console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #e91e63');
    console.groupEnd();
  }, []);

  return null;
};

// ============================================================
// INLINE ACCESS MESSAGE - CORRIGÉ AVEC Link
// ============================================================
const InlineAccessMessage = ({ title = "Accès non autorisé", message }) => (
  <div className="min-h-screen flex items-center justify-center p-6">
    <div className="max-w-lg text-center bg-white p-8 rounded-lg shadow">
      <h1 className="text-5xl font-bold text-pink-600 mb-3">403</h1>
      <h2 className="text-2xl font-semibold mb-2">{title}</h2>
      <p className="text-gray-600 mb-6">{message}</p>
      <div className="flex justify-center space-x-3">
        <Link to="/" className="px-4 py-2 bg-gray-100 rounded hover:shadow">
          Accueil
        </Link>
        <Link
          to="/login"
          className="px-4 py-2 bg-primary-600 text-white rounded hover:shadow"
        >
          Se connecter
        </Link>
      </div>
    </div>
  </div>
);

// ============================================================
// ADMIN ROUTE PROTECTION
// ============================================================
const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.isSuspended || user.status === "suspended" || user.suspended) {
    return (
      <InlineAccessMessage
        title="Compte suspendu"
        message="Votre compte administrateur a été suspendu. Contactez le support."
      />
    );
  }

  if (user.role !== "admin") {
    return (
      <InlineAccessMessage
        title="Accès non autorisé"
        message="Vous n'êtes pas autorisé à accéder à la zone d'administration."
      />
    );
  }

  return children;
};

// ============================================================
// MERCHANT ROUTE PROTECTION
// ============================================================
const MerchantRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (user.isSuspended || user.status === "suspended" || user.suspended) {
    return (
      <InlineAccessMessage
        title="Compte suspendu"
        message="Votre compte marchand a été suspendu. Contactez le support."
      />
    );
  }

  if (user.role !== "merchant" && user.role !== "admin") {
    return (
      <InlineAccessMessage
        title="Accès non autorisé"
        message="Cette zone est réservée aux marchands."
      />
    );
  }

  return children;
};

// ============================================================
// MAIN APP COMPONENT
// ============================================================
function App() {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");
  const isMerchantRoute = location.pathname.startsWith("/merchant");

  const hidePublicLayout = isAdminRoute || isMerchantRoute;

  return (
    <div className="flex flex-col min-h-screen">
      <ConfigDebugger />
      <ScrollToTop />
      {!hidePublicLayout && <Navbar />}

      <main className="flex-grow">
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/deals/:slug" element={<DealDetail />} />
          <Route path="/top-deals" element={<TopDeals />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/about" element={<About />} />
          <Route path="/annonces" element={<Announcements />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/laser-clinic" element={<LaserClinic />} />
          <Route path="/house" element={<House />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failed" element={<PaymentFailed />} />

          {/* PROTECTED ROUTES */}
          <Route
            path="/checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          {/* ADMIN ROUTES */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="deals" element={<AdminDealsManagement />} />
            <Route path="orders" element={<AdminOrdersManagement />} />
            <Route path="users" element={<AdminUsersManagement />} />
            <Route path="merchants" element={<AdminMerchantsManagement />} />
            <Route path="performance" element={<AdminPerformanceDashboard />} />
            <Route path="categories" element={<AdminCategoriesManagement />} />
            <Route path="reviews" element={<AdminReviewsManagement />} />
            <Route path="payments" element={<AdminPaymentsManagement />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="notifications" element={<AdminNotifications />} />
            <Route path="cities" element={<AdminCitiesManagement />} />
          </Route>

          {/* MERCHANT ROUTES */}
          <Route
            path="/merchant"
            element={
              <MerchantRoute>
                <MerchantLayout />
              </MerchantRoute>
            }
          >
            <Route index element={<Navigate to="deals" replace />} />
            <Route path="deals" element={<MyDeals />} />
            <Route path="deals/new" element={<CreateDeal />} />
            <Route path="deals/:id/edit" element={<EditDeal />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!hidePublicLayout && <Footer />}
    </div>
  );
}

export default App;